import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconYoutubeSocial = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.3262V9.67382C10 9.37019 10.325 9.17727 10.5915 9.32266L14.8562 11.6488C15.1342 11.8004 15.1342 12.1996 14.8562 12.3512L10.5915 14.6773C10.325 14.8227 10 14.6298 10 14.3262Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.84981 7.92612C2.91679 6.51024 4.0055 5.37836 5.41852 5.26612C7.05662 5.13599 9.3923 5 12 5C14.6077 5 16.9434 5.13599 18.5815 5.26612C19.9945 5.37837 21.0832 6.51023 21.1502 7.9261C21.2033 9.04764 21.25 10.4699 21.25 12C21.25 13.5301 21.2032 14.9523 21.1502 16.0739C21.0832 17.4897 19.9945 18.6216 18.5815 18.7338C16.9434 18.864 14.6077 19 12 19C9.39227 19 7.05656 18.864 5.41845 18.7338C4.00546 18.6216 2.9168 17.4897 2.84981 16.0738C2.79675 14.9523 2.75 13.5301 2.75 12C2.75 10.4699 2.79674 9.04766 2.84981 7.92612Z",
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.9507 8.66426C10.1843 8.24626 9.25 8.80092 9.25 9.67384V14.3262C9.25 15.1991 10.1844 15.7538 10.9507 15.3358L15.2153 13.0096C16.0144 12.5737 16.0144 11.4263 15.2153 10.9904L10.9507 8.66426ZM13.9338 12L10.75 13.7366V10.2634L13.9338 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 4.25C9.36742 4.25 7.0112 4.38723 5.35912 4.51847C3.56695 4.66084 2.18535 6.10033 2.10064 7.89068C2.04718 9.02081 2 10.4552 2 12C2 13.5447 2.04718 14.9791 2.10065 16.1093C2.18535 17.8996 3.56691 19.3391 5.35905 19.4815C7.01114 19.6127 9.36738 19.75 12 19.75C14.6326 19.75 16.9889 19.6127 18.6409 19.4815C20.4331 19.3391 21.8146 17.8996 21.8993 16.1093C21.9528 14.9792 22 13.5447 22 12C22 10.4552 21.9528 9.02079 21.8993 7.89066C21.8146 6.10032 20.433 4.66084 18.6409 4.51847C16.9888 4.38723 14.6326 4.25 12 4.25ZM5.47791 6.01376C7.10204 5.88474 9.41718 5.75 12 5.75C14.5828 5.75 16.898 5.88474 18.5221 6.01376C19.556 6.09589 20.3517 6.92013 20.401 7.96155C20.4537 9.07449 20.5 10.4845 20.5 12C20.5 13.5154 20.4537 14.9255 20.401 16.0384C20.3517 17.0798 19.556 17.904 18.5221 17.9862C16.898 18.1152 14.5828 18.25 12 18.25C9.41715 18.25 7.10199 18.1152 5.47786 17.9862C4.44402 17.904 3.64824 17.0798 3.59897 16.0384C3.54631 14.9254 3.5 13.5154 3.5 12C3.5 10.4845 3.54631 9.07451 3.59897 7.96157C3.64824 6.92014 4.44404 6.09589 5.47791 6.01376Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconYoutubeSocial as ReactComponent };
